<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;" v-if="!adding">
            <div class="col s1">
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setSubstancesOrder('name')">{{$t('substances.name')}}</span>
                <i class="material-icons dp6" v-if="ordersubstancesby == 'name' && ordersubstances == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordersubstancesby == 'name' && ordersubstances == 'asc'">arrow_drop_up</i>
                <input id="substancesearch" v-model="substancesearch" />
            </div>
            <div class="col s3  input-field">
                <span v-on:click="setSubstancesOrder('permission')">{{$t('substances.permission')}}</span>
                <i class="material-icons dp6" v-if="ordersubstancesby == 'permission' && ordersubstances == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordersubstancesby == 'permission' && ordersubstances == 'asc'">arrow_drop_up</i>
                <input id="substancepermsearch" v-model="substancepermsearch" />
            </div>
            <div class="col s3  input-field">
                <span v-on:click="setSubstancesOrder('group')">{{$t('substances.group')}}</span>
                <i class="material-icons dp6" v-if="ordersubstancesby == 'group' && ordersubstances == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordersubstancesby == 'group' && ordersubstances == 'asc'">arrow_drop_up</i>
                <selector v-model="selectedsubstancesgroups" :items="substancegroupoptions" identifier="substances"></selector>
            </div>
            <div class="col s2  input-field" style="text-align: end;"  v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
                <a class="waves-effect waves-light btn solidgreen" v-on:click="addSubstance()" style="margin-top: 20px;">{{$t('substances.add')}}</a>
            </div>
        </div>
        <ul class="collapsible">
            <li v-if="adding">
                <substance v-bind:substance="newSubstance" v-bind:substance_groups="substancegroupoptions" v-bind:devtypes="devtypes" v-on:addSubstance="addedSubstance" v-on:cancelSubstance="substanceCancelled" ref="newSubstance"/>
            </li>
            <li v-for="substance in listSubstanceItems" :key="substance.id">
                <div class="collapsible-header reded">
                    <div class="row" style="width: 100%;">
                        <div class="col s1">
                            <template v-if="substance.image != null && substance.image != undefined">
                                <v-lazy-image 
                                    v-bind:src="substance.image"
                                    src-placeholder="/nofoto.png"
                                    class="lazy"
                                    alt=""
                                    width="64"
                                    v-on:error="imageLoadError(substance)"
                                />
                            </template>
                            <template v-else>
                                <img src="/nofoto.png" style="width: 64px;"/>
                            </template>
                        </div>
                        <div class="col s3"> {{substance.name}}</div>
                        <div class="col s3"> {{substance.permission}}</div>
                        <div class="col s3"> {{substance.group != undefined ? substance.group.join(",") : ""}}</div>
                    </div>
                </div>
                <substance v-bind:substance="substance" v-bind:substance_groups="substancegroupoptions" v-on:removeSubstance="removeSubstance" v-bind:devtypes="devtypes" v-on:updateSubstance="updatedSubstance" :key="substance.id" ref="substances"/>
            </li>
            <li>
                <div class="row" style="width: 100%;" v-if="substances_loaded == false">
                    <div class="col s12">
                        <div class="container" style="width: 3%; margin: auto;">
                            <div class="preloader-wrapper active">
                                <div class="spinner-layer spinner-red-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="substances_loaded == true && listSubstanceItems.length == 0">
                    <div class="col s12">{{$t('substances.notfound')}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
export default {
    props: { role: String, extended_privileges: Boolean },
    data: function() {
        return {
            ordersubstances: 'asc',
            ordersubstancesby: 'name',
            substancesearch: "",
            substancepermsearch: "",
            substances: [],
            devtypes: [],
            substance_groups: [],
            substances_loaded: false,
            substancegroups: [],
            selectedsubstancesgroups: [],
            substanceoptions: [],
            newSubstance: undefined,
            adding: false
        }
    },
    created() {
        this.fetch_pests();
    },
    mounted() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, { accordion: true });
    },

    methods: {
        removeSubstance: function(substance) {
            var that = this;
            axios.delete("/substances/" + substance.id + ".json").then((response) => {
                that.substances.splice(that.substances.indexOf(_.find(that.substances, {id: substance.id})), 1);
                that.$forceUpdate();
            })
        },
        substanceCancelled: function(){
          this.newSubstance = undefined;
          this.adding = false;
          this.$forceUpdate();
        },
        addedSubstance: function(substance) {
            this.adding = false;
            this.newSubstance = undefined;
            this.substances.push(substance);
            this.$forceUpdate();
        },
        updatedSubstance: function(substance){
            var oldsubstance = _.find(this.substances, {id: substance.id});
            _.assign(oldsubstance, substance);
            this.$forceUpdate();
        },
        anyEdited: function(){
            if(_.isUndefined(this.$refs.substances) == false){
                for (var i = this.$refs.substances.length - 1; i >= 0; i--) {
                    if(this.$refs.substances[i].editedsubstance.edit){
                        return true;
                    }
                }
            }
            if(_.isUndefined(this.$refs.newSubstance) == false){
                if(this.$refs.newSubstance.editedsubstance.edit){
                    return true;
                }
            }
            return false;
        },
        fetch_pests: function() {
            var that = this;
            axios.get('/substances.json').then(response => {
                this.substances = response.data;
                this.substanceoptions = []
                for (var i = this.substances.length - 1; i >= 0; i--) {
                    this.substances[i].edit = false;
                }
                

                this.substances_loaded = true;
            });
            axios.get('/substances/groups.json').then(response => {
                this.substance_groups = response.data;
            });
            axios.get("/dev_types.json").then((response) => {
                this.devtypes = response.data
            });
        },
        addSubstance() {
            this.newSubstance = { edit: true, tag_list: [], name: "", permission: "", documents: [], required_intervention_recommendations: [], dosage_variants: [], media: [], applicable_for: [], groups: [] }
            this.adding = true;
            this.$forceUpdate();
        },
        setSubstancesOrder: function(order) {
            if (this.ordersubstancesby == order) {
                if (this.ordersubstances == 'desc') {
                    this.ordersubstances = 'asc'
                } else if (this.ordersubstances == 'asc') {
                    this.ordersubstances = 'desc'
                }

            } else {
                this.ordersubstancesby = order;
            }
        },
        imageLoadError: function(substance){
            substance.image = null;
        }
    },
    computed: {
        listSubstanceItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.substances, this.ordersubstancesby, this.ordersubstances),
                function(item) {
                    return (
                        (("" + item.name).toUpperCase().indexOf(that.substancesearch.toUpperCase()) >= 0) &&
                        (("" + item.permission).toUpperCase().indexOf(that.substancepermsearch.toUpperCase()) >= 0) &&
                        (_.intersection(that.selectedsubstancesgroups, item.substance_group_ids).length > 0 || that.selectedsubstancesgroups.length == 0)
                    )
                }
            );
        },
        substancegroupoptions() {
            return _.map(this.substance_groups, function(dt) {
                return { name: dt.name, value: dt.id };
            })
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.settingsform {
    padding-top: 15px;
}

.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.input-field {
    margin: 0px !important;
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.collapsible-body .collapsible-header {
    background-color: #FFF;
    text-transform: initial;
}

.collapsible-body .collapsible-header .row {
    margin-bottom: 0px;
}

.collapsible-body .collapsible-body.formul {
    background-color: #FFF;
    margin-top: 5px;
    border-bottom-style: solid;
    border-bottom-width: 5px;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.active>.reded {
    border-color: rgb(194, 32, 38);
    border: 4px solid rgb(194, 32, 38);
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
}

.collapsible-body {
    padding: 1em;
    padding-right: 0em;
    padding-left: 1em;
}

.collapsible li i {
    position: absolute;
    right: 15px;
}

.collapsible li.active i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
    transform: rotate(180deg);
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.btn-small {
    color: black;
    border-radius: 8px;
}
</style>